module.exports = "/_next/static/images/car-line-b03b95c1862dd7a9b6d53bef52566503.svg";